export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const REJECT_APPLICANT = "REJECT_APPLICANT";
